module.exports = __webpack_public_path__ + "img/left1.09e7fa26.png";